import { render, staticRenderFns } from "./OutputAssignmentOfInterventions.vue?vue&type=template&id=7bca50a0"
import script from "./OutputAssignmentOfInterventions.vue?vue&type=script&lang=js"
export * from "./OutputAssignmentOfInterventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports